export default sin => {
  var check, even, tot;

  if (typeof sin === 'number') {
    sin = sin.toString();
  } else {
    sin = sin.replace(/\D/g, '');
  }

  if (sin.length === 9) {
    // convert to an array & pop off the check digit
    sin = sin.split('');
    check = +sin.pop();

    even = sin
      // take the digits at the even indices
      .filter(function(_, i) {
        return i % 2;
      })
      // multiply them by two
      .map(function(n) {
        return n * 2;
      })
      // and split them into individual digits
      .join('')
      .split('');

    tot = sin
      // take the digits at the odd indices
      .filter(function(_, i) {
        return !(i % 2);
      })
      // concatenate them with the transformed numbers above
      .concat(even)
      // it's currently an array of strings; we want numbers
      .map(function(n) {
        return +n;
      })
      // and take the sum
      .reduce(function(acc, cur) {
        return acc + cur;
      });

    // compare the result against the check digit
    return check === (10 - (tot % 10)) % 10;
  }

  return false;
};
